import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import SearchUI from './legacy/searchui';
import Pages from './legacy/pages';
import { Main } from './main/Main';
import * as serviceWorker from './serviceWorker';
import { openTabStore } from './hooks/useCloseStore';
import $ from 'jquery';
import { initConverters } from './views/TranslationTool/converters';

export const ADVANCED_LABEL = 'Advanced';
export const BASIC_LABEL = 'Basic Search';
export const PHONE_WIDTH = 480;
export const HIDE_SIDEBAR_WIDTH = 760;

const queryClient = new QueryClient({
    // From https://www.codemzy.com/blog/react-query-cachetime-staletime
    /*
    defaultOptions: {
    defaultOptions: {
        queries: {
            staleTime: 30 * (60 * 1000), // 30 mins
            cacheTime: 60 * (60 * 1000), // 60 mins
        },
    },
     */
});

export default function App() {
    // Initialize Search UI from Bill's Old Code for Asset Viewers
    if (!window.sui) {
        window.sui = new SearchUI();
    }
    let sui = window.sui;
    if (!window.sui.pages) {
        sui.pages = window.sui.pages = new Pages(sui);
    }

    window.mandala = {};

    initConverters();

    //  Close sidebar for phones
    const changeOpenTab = openTabStore((state) => state.changeButtonState);

    useEffect(() => {
        // Initial Sidebar state as set in WP Mandala Plugin settings
        const sbstate = window?.mandala_wp?.sidebar_state;
        if (!isNaN(sbstate)) {
            changeOpenTab(sbstate * 1);
            /*
            if (sbstate === 0) {
                $('#secondary, .l-content__rightsidebar').attr(
                    'style',
                    'width: 0;'
                );
            }*/
            window.mandala_wp.sidebar_state_processed =
                window.mandala_wp.sidebar_state;
            window.mandala_wp.sidebar_state = false;
        }
    }, [window?.mandala_wp?.sidebar_state]);

    // Service Worker caches calls between windows and tabs of the same browser.
    // console.log("environment: " + process.env.NODE_ENV);
    // serviceWorker.register();

    return (
        <QueryClientProvider client={queryClient}>
            <Main sui={sui} />
        </QueryClientProvider>
    );
}
